export const ENABLE_PANE_LAYOUT = false;
export const ENABLE_LIVE_TICKER = false;

export const HELIXTAP_COMPANY_SLUG = "helixtap";

export const HELIXTAP_INTRODUCER_ID = "19550";

export const TABS = [
  {
    id: "dashboard",
    name: "Overview",
    href: "/helixtap/dashboard",
  },
  {
    id: "priceAssessments",
    name: "Price Assessments",
    href: "/helixtap/price-assessments",
  },
  {
    id: "esg",
    name: "ESG",
    href: "/helixtap/esg",
  },
  {
    id: "predictivePrices",
    name: "Predictive Prices",
    href: "/helixtap/predictive-prices",
  },
  {
    id: "marketInsights",
    name: "Market Insights",
    href: "/helixtap/market-insights",
  },
  {
    id: "news",
    name: "News",
    href: "/helixtap/news",
  },
  {
    id: "tradeFlow",
    name: "Trade Flow",
    href: "/helixtap/trade-flow",
  },
  {
    id: "nrInventory",
    name: "NR Inventory",
    href: "/helixtap/nr-inventory",
  },
  {
    id: "priceSignals",
    name: "Price Signals",
    href: "/helixtap/price-signals",
  },
];

export const METHODS = [
  {
    id: "method1",
    name: "Method 1",
  },
  {
    id: "method2",
    name: "Method 2",
  },
];

export const PRIORITIES = [
  {
    id: "p1",
    name: "P1",
  },
  {
    id: "p2",
    name: "P2",
  },
  {
    id: "p3",
    name: "P3",
  },
  {
    id: "p4",
    name: "P4",
  },
];

export const ACTIVITY_KEY_MAPPING: { [key: string]: string } = {
  "price-signals": "helixtap.pricesignal_view",
  "nr-inventory": "helixtap.nrinventory_view",
  "trade-flow": "helixtap.tradeflow_view",
  news: "helixtap.news_view",
  "market-insights": "helixtap.marketinsights_view",
  "predictive-prices": "helixtap.predictiveprices_view",
  esg: "helixtap.esg_view",
  "price-assessments": "helixtap.priceassessment_view",
  overview: "helixtap.overview_view",
};

export const DEFAULT_ACTIVITY_KEY = "helixtap.view";
